module.exports = __webpack_public_path__ + "img/Vietnam.15531ca8.svg";